export interface Captcha {
    inputValue: string;
    captchaId: string;
    instanceId: string;
    close: () => void;
}

export type ICaptchaType = 'sendCode' | 'auth';

export const CAPTCHA_CANCELLED = 'captchaCancelled';

export function isCaptchaCancelled(error: unknown): boolean {
    return error === CAPTCHA_CANCELLED;
}

export interface IBaseCaptchaParams {
    captchaId?: string;
    inputValue?: string;
    captchaInstanceId?: string;
}
